import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Translation } from 'react-i18next'

class Footer extends Component {
    render() {
        return (
            <div>
                {/* ======= Footer ======= */}
                <footer id="footer">
                    <div className="footer-top">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-3 col-md-6 footer-contact">
                                    <h3>
                                        Argent <br /> Aujourd’hui
                                    </h3>
                                </div>
                                <div className="col-lg-3 col-md-6 footer-links">
                                    <h4>Avantages</h4>
                                    <ul>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/avantages/pret-personnalise">
                                                Prêt personnalisé
                                            </Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/avantages/pret-rapide">Prêt rapide</Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/avantages/pret-sans-enquete-credit">
                                                Prêt sans enquête de crédit
                                            </Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/avantages/pret-sans-refus">
                                                Prêt sans refus
                                            </Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/avantages/pret-virement-immediat">
                                                Prêt virement immédiat
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-lg-3 col-md-6 footer-links">
                                    <h4>Besoins</h4>
                                    <ul>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/besoins/pret-sur-salaire-aucun-refus">
                                                Prêt sur salaire sans aucun refus
                                            </Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/besoins/pret-urgent-rapide">
                                                Prêt urgent rapide
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-lg-3 col-md-6 footer-links">
                                    <h4>Micro prêts</h4>
                                    <ul>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/micro-prets/100">Micro prêt de 100$</Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/micro-prets/200">Micro prêt de 200$</Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/micro-prets/300">Micro prêt de 300$</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div class="d-none d-lg-block col-lg-3 col-md-6 footer-links"></div>
                                <div className="col-lg-3 col-md-6 footer-links">
                                    <h4>Situations</h4>
                                    <ul>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/situations/pret-mauvais-credit">
                                                Prêt mauvais crédit
                                            </Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/situations/pret-sans-emploi">
                                                Prêt sans emploi
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-lg-3 col-md-6 footer-links">
                                    <h4>
                                        <Translation>
                                            {(t) => <span>{t('footer_title2')}</span>}
                                        </Translation>
                                    </h4>
                                    <ul>
                                        <li>
                                            <i className="bx bx-chevron-right" />
                                            <Link to="/new-lead" className="btn-learn-more">
                                                <Translation>
                                                    {(t) => <span>{t('navbar_button')}</span>}
                                                </Translation>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container footer-bottom clearfix">
                        <div className="copyright">
                            © Copyright{' '}
                            <strong>
                                <span>Argent Aujourd'hui</span>
                            </strong>
                            .{' '}
                            <Translation>{(t) => <span>{t('footer_copyright')}</span>}</Translation>
                        </div>
                        <div className="credits">
                            <Translation>{(t) => <span>{t('navbar_title1')}</span>}</Translation>{' '}
                            <a href="#">Voxo Media</a>
                        </div>
                    </div>
                </footer>
                {/* End Footer */}
            </div>
        )
    }
}
export default Footer
